module.exports = __webpack_public_path__ + "game.png?878b0d7f6b6b0290fb57c082e287e342";


//////////////////
// WEBPACK FOOTER
// ./public/img/memories/game.png
// module id = 575
// module chunks = 1